import request from '@/utils/request'

// 查询手环日志列表
export function listWristbandLog(query) {
  return request({
    url: '/system/wristband-log/list',
    method: 'get',
    params: query,
  })
}

// 查询手环日志分页
export function pageWristbandLog(query) {
  return request({
    url: '/system/wristband-log/page',
    method: 'get',
    params: query,
  })
}

// 查询手环日志详细
export function getWristbandLog(data) {
  return request({
    url: '/system/wristband-log/detail',
    method: 'get',
    params: data,
  })
}

// 新增手环日志
export function addWristbandLog(data) {
  return request({
    url: '/system/wristband-log/add',
    method: 'post',
    data: data,
  })
}

// 修改手环日志
export function updateWristbandLog(data) {
  return request({
    url: '/system/wristband-log/edit',
    method: 'post',
    data: data,
  })
}

// 删除手环日志
export function delWristbandLog(data) {
  return request({
    url: '/system/wristband-log/delete',
    method: 'post',
    data: data,
  })
}
